export default __webpack_public_path__ + "static/media/cyber-security.ea41dd62.svg";